/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFareCalcTaxBreakdownFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeFareCalcTaxBreakdown, serializeFareCalcTaxBreakdownCreateRequest, serializeFareCalcTaxBreakdownUpdateRequest, type FareCalcTaxBreakdown, type FareCalcTaxBreakdownCreateRequest, type FareCalcTaxBreakdownUpdateRequest, type ValidationProblemDetails } from '../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /FareCalcTaxBreakdowns
 */
export interface FareCalcTaxBreakdownsRequestBuilder extends BaseRequestBuilder<FareCalcTaxBreakdownsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FareCalcTaxBreakdown[]>}
     */
     get(requestConfiguration?: RequestConfiguration<FareCalcTaxBreakdownsRequestBuilderGetQueryParameters> | undefined) : Promise<FareCalcTaxBreakdown[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FareCalcTaxBreakdown>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: FareCalcTaxBreakdownCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FareCalcTaxBreakdown | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     put(body: FareCalcTaxBreakdownUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<FareCalcTaxBreakdownsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FareCalcTaxBreakdownCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: FareCalcTaxBreakdownUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface FareCalcTaxBreakdownsRequestBuilderGetQueryParameters {
    isActive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const FareCalcTaxBreakdownsRequestBuilderUriTemplate = "{+baseurl}/FareCalcTaxBreakdowns{?isActive*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const FareCalcTaxBreakdownsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FareCalcTaxBreakdownsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createFareCalcTaxBreakdownFromDiscriminatorValue,
    },
    post: {
        uriTemplate: FareCalcTaxBreakdownsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFareCalcTaxBreakdownFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFareCalcTaxBreakdownCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: FareCalcTaxBreakdownsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFareCalcTaxBreakdownUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
